export const isObjectEmpty = {
  methods: {
    emptyObject (someObject) {
      const x = Object.keys(someObject).length
      if (x === 0) return true
    }
  }
}
